<style src='@/resources/styles/results.css' scoped></style>

<template>

    <div class='type-filter filter'>
        <span class='caption'>
          Type <span class='help-mark'></span>
      </span>

        <div class='toggle' v-for="(type, i) in proj.types">

            <span class='toggle-label'>{{ typeLabel(type) }}</span>
            <button class='toggle-button' v-bind:class="{on: isTypeActive(type), disabled: disableAll}"
                    :disabled="disableAll"
                    v-on:click="typeChanged(type)">
                <span class='toggler'></span>
            </button>
        </div>


        <div class='mix-filter' v-if="hasTransplants" v-bind:class="{disabled: transplantsDisabled}">
            <span class='label'>mix settings:</span>
            <button  v-for="(syll, i) in availableSylls"
                     v-bind:class="{on: isSyllActive(syll), disabled: disableAll}"
                     v-on:click="syllChanged(syll)"
                     :disabled = transplantsDisabled
                     class="sticky-button">{{syll.hint}}</button>
        </div>

        <!--
        <div class='mix-filter' v-if="! hasTransplants">
            No mixed results - keywords too short
        </div> -->
    </div>
</template>

<script>
  import { mapGetters, mapMutations, mapActions } from 'vuex'
  export default {
    name: 'WordTypeFilter',



      data: function() {
        return {
        }
    },

    computed: {
        ...mapGetters(['proj', 'filters', 'availableSylls', 'isTypeActive', 'isSyllActive',
                      'isFiltering']),
        hasTransplants() {
          return this.proj.types.includes("TRANSPLANT");
        },

        transplantsDisabled() {

            if (this.disableAll)
                return true;

            if (this.availableSylls.length <= 0)
                return true;

            return ! this.filters.types.includes("TRANSPLANT")
        },

        disableAll: function() {
            return this.isFiltering;
        }
    },

    methods: {
        ...mapMutations(['chooseSyll', 'chooseType', 'setPage']),
        ...mapActions(['filter']),

        typeLabel(type) {
            switch (type)
            {
                case "PREFIX":
                    return "Prefix";
                case "SUFFIX":
                    return "Suffix";

                case "TRANSPLANT":
                    return  "Mix";

                default:
                    return type;
            }
        },

        typeChanged(type) {
            this.chooseType(type);
            this.setPage(1);
            const payload = {filters: this.filters};
            this.filter(payload)
                        .then(x => window.scrollTo(0,0));
        },

        syllChanged(syll) {
            this.chooseSyll(syll);
            this.setPage(1);
            const payload = {filters: this.filters};
            this.filter(payload, "");
        }

    },
  }
</script>